import { type Theme } from '@hurdl/design-system';

/**
 * The theme of frontend, as the Design_System is handed it.
 *
 * Package-owned. Written once when the package was created and never rewritten, so
 * the display name below is yours to change; `pnpm sync` will not put it back.
 *
 * A `Theme` is a value rather than a name the Design_System recognises. It ships one
 * reference theme and never learns that a product exists, so this application
 * declares its own class in `src/theme.css` and passes it here — which is what keeps
 * a product's brand change a change to the product (ADR 0005).
 *
 * `name` is a label shown in a theme selector, so it is written for a reader. The
 * class name is not: it follows the `hurdl-theme-` convention that keeps a theme
 * class recognisable in rendered markup, and it must match the selector
 * `src/theme.css` declares.
 */
export const APPLICATION_THEME: Theme = {
  name: 'Admin Panel',
  className: 'hurdl-theme-admin-panel',
};
